import PromoSignUp from './promosignup'
export default PromoSignUp
